import { useMemo } from 'react';
// utils
import { fetcher, endpoints, poster, patcher } from '../utils/axios';

export async function getAllReports(payload){
    const URL = endpoints.reports.list
    return await fetcher([URL, {params:payload}] )
}

export async function updateReportStatus(payload) {
    const URL = endpoints.interpretation.requestInterpretation;
    return await poster([URL,payload])
}
export async function revokeInterpretationRequest(payload) {
    const URL = endpoints.interpretation.revokeInterpretationRequest;
    return await poster([URL,payload])
}
export async function getEcgData(param, payload) {
    const URL = endpoints.data.getEcgData
    return await fetcher([ URL+`${param}`, { params: payload }])
}
export async function getEcgReportAndData(payload) {
    const URL = endpoints.data.getEcgReportAndData
    return await fetcher([ URL+`${payload.id}`])
}
export async function saveDataInterpretation(payload) {
    const URL = endpoints.interpretation.saveDataInterpretation;
    return await patcher([ URL,payload.bodyData])
}
// export async function getB2Busers(payload) {
//     const URL = endpoints.loginProcess.getB2Busers
//     //Path Params 
//     return await fetcher([URL+`${""}`])
// }
export async function getSpecificInvoiceData(payload){
    const URL = endpoints.data.getSpecificInvoiceData
    return await fetcher([URL, { params: payload }])
}

export async function downloadLeadFile(payload, config) {
    const URL = endpoints.data.downloadLeadFile;
    return await fetcher([URL, { params: payload, ...(config || {}) }])
}

export async function careLogAiInterpretation(payload) {
    const URL = endpoints.interpretation.careLogAiInterpretation;
    return await fetcher([URL, { params: payload }])
}
export async function getCenterDetails(param, payload) {
    const URL = endpoints.center
    return await fetcher( [URL,  payload] )
}

export async function getPrescription(param, payload) {
    const URL = endpoints.interpretation.getPrescription;
    return await fetcher([ URL+`${param}`, { params: payload }])
}

export async function getReportInterpretaionStatus(param, payload) {
    const URL = endpoints.reports.getInterpretationStatus;
    return await fetcher([ URL+`${param}`, { params: payload }])
}

export async function LeadTraceMatrix(payload) {
  const URL = endpoints.interpretation.LeadTraceMatrix;
  return await poster([URL, payload]);
}
export async function CollectionsData(param, payload) {
    const URL = endpoints.interpretation.reportData;
    return await fetcher([ URL+`${param}`, { params: payload }])
}

export async function getAllReplicas(payload){
    const URL = endpoints.reports.getlistreplica
    return await fetcher([URL, {params:payload}] )
}

export async function saveInterpretationReplica(payload) {
    const URL = endpoints.interpretation.saveDataInterpretationReplica;
    return await patcher([ URL,payload.bodyData])
}

export async function getReplicaInterpretationData({ id, replicadata, ...payload }) {
  const URL = endpoints.data.getEcgData;
  return await fetcher([
    `${URL}${id}`,
    { params: { replicadata, ...payload } }
  ]);
}

export async function revokeReplicaInterpretationRequest(payload) {
    const URL = endpoints.interpretation.revokeInterpretationRequest;
    return await poster(URL,payload,true)
}
